import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/flagship/u7-lite.png";
import { type Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u7lite: Product = {
  id: "u7lite",
  productTitle: "U7 Lite",
  description: "u7lite.description",
  storePathParts: {
    category: UniFiChildCategorySlug.WiFiFlagship,
    productSlug: "u7-lite",
  },
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u7-lite`],
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7lite.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7lite.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "115 m² (1,250 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "200+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u7Lite.uplink" },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
